/**
 * Canonical trip color palette for dispatch-v2. Used by the trip color picker,
 * the assign-driver dialog, and operator avatar coloring. Keep this the single
 * source — don't re-inline the hex list elsewhere.
 */
export const TRIP_COLORS = [
  "#4f46e5",
  "#0891b2",
  "#16a34a",
  "#d97706",
  "#db2777",
  "#7c3aed",
  "#0d9488",
] as const;

/** Default trip accent when a trip has no color set. */
export const DEFAULT_TRIP_COLOR = "#6366f1";

/** Deterministic palette color from an id (e.g. operator avatars). */
export function colorFromId(id: string): string {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) & 0xffff;
  return TRIP_COLORS[h % TRIP_COLORS.length];
}
